import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatNativeDateModule, ThemePalette } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { QuoteStepperComponent } from 'app/modules/quotes/quote-stepper/quote-stepper.component';
import { DropdownComponent } from './cinico-dropdown/dropdown.component';
import { ToggleButtonsComponent } from './toggle-buttons/toggle-buttons.component';
import { DeclarationComponent } from './declaration/declaration.component';
import { InputComponent } from './cinico-input/input.component';

export type { ThemePalette as MaterialThemePalette };
export type { MatDatepickerInputEvent as MaterialDatePickerInputEvent };

const materialModules = [
  CommonModule,
  MatButtonModule,
  MatSidenavModule,
  MatToolbarModule,
  MatIconModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatNativeDateModule,
  MatInputModule,
  MatAutocompleteModule,
  MatCardModule,
  MatProgressBarModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatChipsModule,
  MatMenuModule,
  MatListModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatButtonToggleModule,
  MatTooltipModule,
  MatTabsModule,
  MatStepperModule,
  TextFieldModule,
  MatRadioModule,
  MatExpansionModule,
  ReactiveFormsModule,
  FormsModule,
  MatSnackBarModule,
  FlexLayoutModule,
  CdkStepperModule,
  NgTemplateOutlet,

  TranslateModule.forChild({ extend: true })
];

@NgModule({
  imports: [
    materialModules,
    DropdownComponent,
    QuoteStepperComponent,
    DeclarationComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ToggleButtonsComponent,
    InputComponent
  ],
  providers: [provideNgxMask()],
  exports: [
    materialModules,
    DropdownComponent,
    QuoteStepperComponent,
    DeclarationComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ToggleButtonsComponent,
    InputComponent
  ]
})
export class SharedComponentsModule {}
